<template>
  <div id="kiosk-login-page" class="row w-100 justify-content-center">
    <div class="col-12 col-md-7 col-lg-6">
      <h1 class="mb-2">Salon sign-in</h1>
      <p class="mb-4">Enter the kiosk password to continue.</p>
      <div class="card card-body text-left" style="border-radius: 14px;">
        <error-banner v-if="error" :message="error" class="mb-3"/>
        <form @submit.prevent="submit">
          <label class="font-weight-bold mb-2">Password</label>
          <password-input v-model="password" placeholder="Password" @keydownEnter="submit"/>
          <button type="submit" class="btn btn-primary mt-4 w-100" :disabled="submitting || !password">
            {{ submitting ? 'Signing in…' : 'Unlock Kiosk' }}
          </button>
        </form>
        <div class="p2 mt-3 text-center text-muted">
          If you've forgotten the password, an admin can change it.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SelectedSiteIdMixin } from '@/mixins/Booking/SelectedSiteIdMixin'
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import PasswordInput from '../Authentication/PasswordInput.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'

export default {
  name: 'KioskLogin',
  mixins: [SelectedSiteIdMixin],
  data () {
    return { password: '', submitting: false, error: '' }
  },
  methods: {
    submit () {
      const self = this
      self.submitting = true
      self.error = ''
      WebApi.post(`Authentication/Site/${self.selectedSiteId}/Kiosk/Login`, { password: self.password })
        .then(() => { self.$emit('authenticated') })
        .catch(error => {
          self.error = ErrorHelper.isNotAuthenticated(error)
            ? 'Invalid username or password'
            : ErrorHelper.getError(error)
        })
        .finally(() => { self.submitting = false })
    }
  },
  components: {
    'password-input': PasswordInput,
    'error-banner': ErrorBanner
  }
}
</script>

<style scoped>
@media (max-width: 576px) {
  #kiosk-login-page h1 { font-size: 1.375rem !important; }
}
</style>
